import React, { useState } from 'react';
import { Download, Loader } from 'lucide-react';
import { fetchWithAuth } from './utils/api';
import toast from 'react-hot-toast';
import { useContext } from 'react';
import { AuthContext } from './AuthContext';

function FileDownloadButton({ s3Key, filename, className = '' }) {
  const { organization } = useContext(AuthContext);  // ✅ Get organization from context
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      // ✅ Use fetchWithAuth instead of manual fetch
      const data = await fetchWithAuth(
        `/download-file?s3_key=${encodeURIComponent(s3Key)}&filename=${encodeURIComponent(filename)}`,
        organization?.organizationId
      );

      // Open download URL in new tab (triggers download)
      window.open(data.download_url, '_blank');
      
      toast.success(`Downloading ${filename}`);

    } catch (error) {
      console.error('Download error:', error);
      toast.error('Failed to download file');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      disabled={downloading}
      className={`flex items-center space-x-2 px-3 py-1.5 bg-blue-600 text-white rounded hover:bg-blue-700 transition disabled:bg-gray-400 disabled:cursor-not-allowed text-sm ${className}`}
      title={`Download ${filename}`}
    >
      {downloading ? (
        <Loader className="w-4 h-4 animate-spin" />
      ) : (
        <Download className="w-4 h-4" />
      )}
      <span>{downloading ? 'Downloading...' : 'Download'}</span>
    </button>
  );
}

export default FileDownloadButton;